import { useEffect } from "react";
import { ViewCard } from "./card";
import { ViewNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { ViewsTable } from "./table";

export default function Views() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Vues");
  }, []);

  return (
    <Routes>
      <Route index element={<ViewsTable />} />
      <Route path="/new" element={<ViewNew />} />
      <Route path=":id" element={<ViewCard />} />
    </Routes>
  );
}
